




































import { Component, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Typography
  }
})
export default class ToBeScheduledBar extends Vue {
  onClick() {
    segmentIo.track('Clicked Schedule Onboarding Call Banner');

    this.$emit('click');
    window.open(
      `${process.env.VUE_APP_DASHBOARD_URL}/schedule-onboarding-call`,
      '_blank'
    );
  }
}
